module.exports = __webpack_public_path__ + "static/media/java.22d65517.png";